import { styled, Typography, TypographyProps } from '@mui/material';

export const Root = styled((props: TypographyProps) => <Typography variant="paragraphRegular" {...props} />)(
  ({ theme }) => ({
    color: theme.palette.grey[700],
    textAlign: 'center',
    padding: theme.spacing(2),
  })
);
